import React from 'react'

function ThoughtCard({thought}) {

    const {id, title, desc, img} = thought

    return (
      <article key={id} className='portfolioItem'>
        <div className="imgBox"><img className="portfolioItemImg" src={img} alt="RecentWork" /></div>
        <h3 className='portfolioItemTitle'>{title}</h3>
        <p>{desc}</p>
      </article>
    )
}

export default ThoughtCard